import { render, staticRenderFns } from "./signUp.vue?vue&type=template&id=05d757d1&scoped=true&"
import script from "./signUp.vue?vue&type=script&lang=js&"
export * from "./signUp.vue?vue&type=script&lang=js&"
import style0 from "./signUp.vue?vue&type=style&index=0&id=05d757d1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d757d1",
  null
  
)

export default component.exports